import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: () => import('@/views/Layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/Dashboard'),
      },
      {
        path: 'accounts',
        component: () => import('@/views/Accounts'),
      },
      {
        path: 'transactions',
        component: () => import('@/views/Transactions'),
      },
      {
        path: 'installments',
        component: () => import('@/views/Installments'),
      },
      {
        path: 'configs',
        component: () => import('@/views/Configs'),
      },
      {
        path: 'import',
        component: () => import('@/views/Import'),
      }
    ],
  }, {
    path: '/',
    component: () => import('@/views/Layouts/AuthLayout'),
    children: [
      {
        path: '/login',
        component: () => import('@/views/Login'),
        meta: { guest: true },
      },
      {
        path: '/register',
        component: () => import('@/views/Register'),
        meta: { guest: true },
      }
    ],
  }],
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/login');
  }

  if (to.meta.guest && isAuthenticated) {
    return next('/');
  }
  next();
});

export default router;
